import { render } from "./StakeholderView.vue?vue&type=template&id=8aef574e"
import script from "./StakeholderView.vue?vue&type=script&lang=js"
export * from "./StakeholderView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__